<template>
  <Bar :data="chartData" :options="chartOptions" />
</template>
<script>
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'bar-chart',
  components: {
    Bar
  },
  props: {
    chartLabels: Array,
    dataValues: Array,
    axisLabel: String
  },
  data: function () {
    return {
      chartData: {
        labels: this.chartLabels,
        datasets: [{
          data: this.dataValues,
          backgroundColor: 'rgba(0, 121, 107, 1)',
          hoverBackgroundColor: 'rgba(0, 121, 107, 0.8)',
          datalabels: {
            anchor: 'end',
            align: 'end',
          }
        }],
      },
      chartOptions: {
        indexAxis: 'y',
        title: {
          display: false
        },
        scales: {
          y: {
            barPercentage: 0.6,
            gridLines: {
              display: false
            },
          },
          x: {
            scaleLabel: {
              display: this.axisLabel != null,
              labelString: this.axisLabel
            },
            ticks: {
              suggestedMax: 0,
              suggestedMin: 0,
              stepSize: 5
            }
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
          },
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    dataProcess: function () {
      this.chartOptions.scales.x.ticks.suggestedMax = this.dataValues.reduce(function (a, b) {
        return Math.max(a, b);
      }) + 4;

      let lowestValue = this.dataValues.reduce(function (a, b) {
        return Math.min(a, b)
      });

      if (lowestValue < 0) {
        this.chartOptions.scales.x.ticks.suggestedMin = lowestValue - 5;
      }

      // var colours = this.dataValues.map((value) => value < 0 ? 'red' : 'rgba(0, 121, 107, 1)');
      this.chartData.datasets[0].datalabels.anchor = this.dataValues.map((value) => value < 0 ? 'start' : 'end');
      this.chartData.datasets[0].datalabels.align = this.dataValues.map((value) => value < 0 ? 'start' : 'end');
    }
  },
  mounted: function () {
    this.dataProcess();
  }
}
</script>

